import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import {
  SiaColorContrastAutoDirective,
  SiaTooltipDirective,
  SiaTranslatePipe,
} from '@sia/shared';
import { NgxColorsModule } from 'ngx-colors';
import { SiaBaseEditorSignalComponent } from '../sia-base-editor/sia-base-editor-signal.component';
import { SiaErrorHintComponent } from '../sia-error-hint/sia-error-hint.component';

@Component({
  selector: 'sia-color-box',
  templateUrl: './sia-color-box.component.html',
  styleUrls: ['./sia-color-box.component.scss'],
  standalone: true,
  imports: [
    SiaColorContrastAutoDirective,
    SiaErrorHintComponent,
    SiaTooltipDirective,
    SiaTranslatePipe,
    NgxColorsModule,
    MatFormField,
    FormsModule,
    MatInput,
    MatLabel,
    MatHint,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiaColorBoxComponent extends SiaBaseEditorSignalComponent {}
